import React, { memo, useMemo } from "react";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";

import CustomSnackbar from ".";
import Helpers from "../../commons/helpers";
import { Palette } from "@mui/material";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} {...props} />;
});

export interface ISnackbarAlertProps {
    onClose?: () => void;
    autoHideDuration?: number;
    dataAlert?: { message: string; type: "warning" | "success" | "error" | "info" };
}

const SnackbarAlert: React.FC<ISnackbarAlertProps> = ({ dataAlert, onClose, autoHideDuration }: ISnackbarAlertProps) => {
    const isShowSnackbar = useMemo(() => {
        if (!Helpers.isNullOrEmpty(dataAlert?.message)) {
            return true;
        } else {
            return false;
        }
    }, [dataAlert?.message]);

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        Helpers.isFunction(onClose) && onClose();
    };

    const severity = useMemo<AlertColor>(() => {
        if (dataAlert?.type === "warning") return "warning";
        if (dataAlert?.type === "success") return "success";
        if (dataAlert?.type === "error") return "error";
        return "info";
    }, [dataAlert?.type]);

    if (Helpers.isNullOrEmpty(dataAlert?.message)) return null;

    return (
        <CustomSnackbar
            open={isShowSnackbar}
            autoHideDuration={!Helpers.isNullOrEmpty(autoHideDuration) ? autoHideDuration : 5000}
            onClose={(event: any, reason: any) => handleClose(event, reason)}
        >
            <Alert
                variant="outlined"
                onClose={handleClose}
                severity={severity}
                sx={({ palette, functions: { rgba } }) => ({
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    color: palette[dataAlert?.type as keyof Palette].main,
                    // color: palette["dark"].main,

                    backgroundColor: rgba(palette[dataAlert?.type as keyof Palette].main, 0.05),
                    boxShadow: "none",
                })}
            >
                {dataAlert?.message || ""}
            </Alert>
        </CustomSnackbar>
    );
};

export default memo(SnackbarAlert);
